import { Component, Inject } from '@angular/core'
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-delete_or_resolve-dialog',
  templateUrl: './bot-delete_or_resolve-dialog.component.html',
  styleUrls: ['./bot-delete_or_resolve-dialog.component.scss'],
  standalone: false,
})
export class BotDeleteOrResolveDialogComponent {
  public title
  readonly noLabel: string
  readonly yesLabel: string

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
  ) {
    this.title = data
    this.noLabel = this.translate.instant('common.no')
    this.yesLabel = this.translate.instant('common.yes')
  }

  get heading(): string {
    return this.translate.instant('shared.deleteOrResolveDialog.title', {
      action: this.title,
    })
  }
}
